import { useMutation } from '@tanstack/react-query';
import { apiClient, ensureCsrfCookie } from '../../api/client';

/**
 * Восстановление доступа по коду из СМС.
 *
 * Почтой система ничего не отправляет (решение владельца 11.08.2026), поэтому
 * единственный канал — телефон. Три шага: попросить код → предъявить код →
 * поставить новый пароль по одноразовому пропуску.
 */

export interface ForgotResponse {
  sent: boolean;
  /** Хвост номера для экрана «код отправлен на …»; null, если номер неразборчив. */
  phone_mask: string | null;
  expires_in: number;
}

export interface VerifyResponse {
  reset_token: string;
  expires_in: number;
}

export function useForgotPassword() {
  return useMutation({
    mutationFn: async (phone: string): Promise<ForgotResponse> => {
      await ensureCsrfCookie();
      const { data } = await apiClient.post('/auth/password/forgot', { phone });
      return data.data as ForgotResponse;
    },
  });
}

export function useVerifyResetCode() {
  return useMutation({
    mutationFn: async (args: { phone: string; code: string }): Promise<VerifyResponse> => {
      await ensureCsrfCookie();
      const { data } = await apiClient.post('/auth/password/verify', args);
      return data.data as VerifyResponse;
    },
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: async (args: {
      reset_token: string;
      password: string;
      password_confirmation: string;
    }): Promise<{ reset: boolean }> => {
      await ensureCsrfCookie();
      const { data } = await apiClient.post('/auth/password/reset', args);
      return data.data as { reset: boolean };
    },
  });
}
